import { makeStyles, withStyles } from '@material-ui/core/styles';
import AutocompleteMUI from '@material-ui/lab/Autocomplete';

export const useStyles = makeStyles((theme) => ({
  autocompleteTag: {
    border: '1px solid #78909C',
    borderRadius: 4,
    padding: '0px 14px 0px 12px',
    color: '#37474F',
    fontSize: 14,
    height: 28,
    marginRight: theme.spacing(1),

    display: 'flex',
    alignItems: 'center',

    [theme.breakpoints.down('xs')]: {
      marginRight: theme.spacing(0.5),
      padding: '0px 10px 0px 8px',
    },
  },
  autocompleteTagRemoveBtn: {
    width: 15,
    height: 15,
    marginLeft: 6,
  },
  autocompleteTagRemoveIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > svg': {
      color: '#546E7A',
    },
  },
}));

export const StyledAutocomplete = withStyles((theme) => ({
  root: {
    padding: '6px 13px',
    border: '1px solid #ECEFF1',
    borderRadius: 4,
    marginTop: 24,
  },
  option: {
    padding: '26px 30px',
    color: '#37474F',
  },
  listbox: {
    padding: 0,
    boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.25)',
    border: '1px solid #ECEFF1',
  },
  inputRoot: {
    rowGap: theme.spacing(1),

    [theme.breakpoints.down('xs')]: {
      rowGap: theme.spacing(0.5),
    },
  },
  input: {
    border: 0,

    '&::placeholder': {
      color: '#78909C',
      fontSize: 14,
      opacity: 1,
    },
  },
  popupIndicator: {
    color: '#546E7A',
    padding: '0 4px 4px',
  },
  popupIndicatorOpen: {
    transform: 'none',
  },
}))(AutocompleteMUI);
